import { render, staticRenderFns } from "./SmartTableFooter.vue?vue&type=template&id=8fcf9378&scoped=true"
import script from "./SmartTableFooter.vue?vue&type=script&lang=js"
export * from "./SmartTableFooter.vue?vue&type=script&lang=js"
import style0 from "./SmartTableFooter.vue?vue&type=style&index=0&id=8fcf9378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcf9378",
  null
  
)

export default component.exports